import { URL_PARAMS } from 'hooks/common/constants';

import BrowserStorage from './browserStorage';

export const getAwsId = (): string | null => {
    const paramName = URL_PARAMS.AWS_ID_PARAM_NAME;

    const awsIdFromParams = new URLSearchParams(window.location.search).get(paramName);
    const storedAwsId = BrowserStorage.getItem(paramName);

    if (awsIdFromParams && awsIdFromParams !== storedAwsId) {
        BrowserStorage.setItem(paramName, awsIdFromParams);

        return awsIdFromParams;
    }

    return storedAwsId ?? null;
};
